import type { ProjectPlan } from "@/types/api";

/** Plan name as shown in the picker. Plans always have a name in the API. */
export function planDisplayName(plan: ProjectPlan): string {
  return plan.name;
}

/** Thumbnail URL when the plan has a latest revision with one. */
export function planThumbnailUrl(plan: ProjectPlan): string | null {
  return plan.latest_revision?.thumbnail_url ?? null;
}
